import type { FaireProductEntity } from "../../entity_types/product";

export const p_v2u2uj8h9s: FaireProductEntity = {
  token: "p_v2u2uj8h9s",
  type: "product",
  name: "privé sample box",
  brandToken: "b_b68c3l2ppb",
  brandName: "privé",
  imageUrl:
    "https://cdn.faire.com/fastly/ce41422895502f902a5556235226c6e071497531be150abd3a7f809c995b390e.png",
  galleryImageUrls: [],
  priceDollars: 25,
  description:
    "Discover award-winning products with our sample box.  Salon quality, clean, luxury formulas you can trust.\n\nincludes:\n3 oz smoothing solution\n3 oz finishing texture spray\n1 oz amp up duo\n1 oz moisture rich duo\n1 oz damage fix duo",
  tags: [],
  msrpDollars: 78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:46.192Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
